import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { useSocketEvents } from '../../hooks/useSocketEvents';
import { useDeviceId } from '../../hooks/useDeviceId';

const Uuid = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  background: #000000;
  color: #ff0000;
  padding: 12px 20px;
  border-radius: 8px;
  font-family: monospace;
  font-size: 16px;
  font-weight: 600;
  z-index: 9999;
  border: 2px solid #ff0000;
  box-shadow: 0 4px 12px rgba(255, 0, 0, 0.2);
  pointer-events: none;
`;

const UuidOverlay: FC = (): ReactElement | null => {
  const { showUuid } = useSocketEvents();
  const deviceId = useDeviceId();

  if (!showUuid) return null;

  return <Uuid>{deviceId}</Uuid>;
};

export default UuidOverlay;
